enum httpResponse {
	unauthorized = 'Unauthorized'
}

export default httpResponse